import React, { useId } from 'react';
import './BrandLogo.css';

interface BrandLogoProps {
  variant?: 'navbar' | 'intro';
  className?: string;
}

/** Arched red wordmark (curved, Netflix-style). */
const BrandLogo: React.FC<BrandLogoProps> = ({ variant = 'navbar', className = '' }) => {
  const uid = useId().replace(/:/g, '');
  const archId = `brand-arch-${variant}-${uid}`;

  const isIntro = variant === 'intro';

  return (
    <svg
      className={`brand-logo brand-logo--${variant} ${className}`.trim()}
      viewBox={isIntro ? '0 0 1200 200' : '0 0 520 72'}
      role="img"
      aria-label="Keshav Mishra"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <path
          id={archId}
          d={isIntro ? 'M 36 148 Q 600 52 1164 148' : 'M 6 54 Q 260 18 514 54'}
          fill="none"
        />
      </defs>
      <text
        fill="#e50914"
        fontFamily="'Bebas Neue', Impact, 'Arial Black', sans-serif"
        fontSize={isIntro ? 118 : 48}
        fontWeight={700}
        letterSpacing={isIntro ? 4 : 2}
      >
        <textPath href={`#${archId}`} startOffset="50%" textAnchor="middle">
          KESHAV MISHRA
        </textPath>
      </text>
    </svg>
  );
};

export default BrandLogo;
